import React from 'react';
import { getChannelHref } from '../../data/socialConfig';
import { trackChannelClick } from '../../utils/analytics';

/**
 * Link to one of our channels (telegram, whatsapp, instagram, x): URL from socialConfig,
 * GA4 `channel_click`, Telegram/WhatsApp through /api/go (counted in the admin dashboard).
 */
const ChannelLink = ({ channel, placement, onClick, children, ...rest }) => (
  <a
    href={getChannelHref(channel, placement)}
    target="_blank"
    rel="noopener noreferrer"
    onClick={(e) => {
      trackChannelClick(channel, placement);
      onClick?.(e);
    }}
    {...rest}
  >
    {children}
  </a>
);

export default ChannelLink;
